import { useBreakpoints, useLoading } from "best-common-react";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { matchRoutes } from "react-router";
import { useLocation, useParams } from "react-router-dom";
import Protected from "../components/protected/Protected";
import RelatedVideos from "../components/video/RelatedVideos";
import VideoBody from "../components/video/VideoBody";
import { RouteConstants } from "../constants/RouteConstants";
import { getVideoPreview, getVideoWithRelated } from "../httpClients/ClipsApi";
import { BoxFileDTO } from "../types/Video";

const VideoContainer: React.FC = () => {
  const { isMobile } = useBreakpoints();
  const { videoId } = useParams();
  const currentLocation = useLocation();
  const isPreview = matchRoutes([{ path: RouteConstants.VIDEO_PREVIEW }], currentLocation);
  const { setLoading } = useLoading();
  const [video, setVideo] = useState<BoxFileDTO | undefined>(undefined);

  const getVideoData = async () => {
    if (!!videoId) {
      try {
        setLoading(true);
        const result: BoxFileDTO = isPreview
          ? await getVideoPreview(parseInt(videoId))
          : await getVideoWithRelated(parseInt(videoId));
        setVideo(result);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    void getVideoData();
  }, [videoId]);

  return (
    <div className={clsx("d-flex", isMobile ? "flex-column" : "flex-row")} style={{ gap: "1rem" }}>
      {!!video && (
        <div style={{ flexGrow: 1 }}>
          <VideoBody video={video} setVideo={setVideo} />
        </div>
      )}
      {!isPreview && !!video && (
        <div style={{ maxWidth: 400, minWidth: 350 }}>
          <RelatedVideos relatedFiles={video.relatedFiles} />
        </div>
      )}
    </div>
  );
};

export default Protected(VideoContainer);
